function safeToFixer(target, fixed = 0) {
  let res = '';
  try {
    res = target.toFixed(fixed);
  } catch (e) {
    res = '';
  }

  return res;
}
export default safeToFixer;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/portfolio/analysis/utils/safeToFixer.js